(function () {
  "use strict";

  var brands = [
    {
      key: "rolex",
      label: "Rolex",
      role: "Main specialty",
      items: [
        ["All Rolex", "/collections/luxury-collection"],
        ["Datejust", "/collections/classic-date-collection"],
        ["Daytona", "/collections/chronograph-collection"],
        ["Day-Date", "/collections/executive-collection"],
        ["GMT-Master II", "/collections/dual-time-collection"],
        ["Yacht-Master", "/collections/marine-sports-collection"],
      ],
    },
    {
      key: "audemars piguet",
      label: "Audemars Piguet",
      role: "Selected references",
      items: [
        [
          "All Audemars Piguet",
          "/collections/integrated-bracelet-collection",
        ],
        ["Royal Oak", "/collections/octagonal-bezel-collection"],
        [
          "Royal Oak Offshore",
          "/collections/chronograph-bezel-collection",
        ],
        [
          "Royal Oak Chronograph",
          "/collections/royal-oak-chronograph",
        ],
        ["Skeleton & Openwork", "/collections/skeleton-collection"],
      ],
    },
    {
      key: "patek philippe",
      label: "Patek Philippe",
      role: "Selected references",
      items: [
        ["All Patek Philippe", "/collections/dress-collection"],
        ["Nautilus", "/collections/octagonal-sports-collection"],
        ["Aquanaut", "/collections/sports-elegance-collection"],
      ],
    },
  ];

  function normalizedText(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  var facetTranslations = {
    "供货情况": "Availability",
    "价格": "Price",
    "有货": "In stock",
    "缺货": "Out of stock",
  };

  function localizeFacets() {
    var drawer = document.getElementById("t4s-filter-hidden");
    if (!drawer || !document.createTreeWalker) {
      return;
    }
    var walker = document.createTreeWalker(
      drawer,
      NodeFilter.SHOW_TEXT,
      null,
    );
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue || "";
      var translated = value;
      Object.keys(facetTranslations).forEach(function (source) {
        translated = translated.split(source).join(
          facetTranslations[source],
        );
      });
      if (translated !== value) {
        node.nodeValue = translated;
      }
    }
  }

  function brandForText(value) {
    var text = normalizedText(value);
    for (var index = 0; index < brands.length; index += 1) {
      if (text.indexOf(brands[index].key) !== -1) {
        return brands[index];
      }
    }
    return null;
  }

  function buildLinks(brand, mobile) {
    var fragment = document.createDocumentFragment();
    brand.items.forEach(function (item) {
      var link = document.createElement("a");
      link.href = item[1];
      link.textContent = item[0];
      if (mobile) {
        var listItem = document.createElement("li");
        listItem.className = "t4s-menu-item t4s-item-level-1";
        listItem.appendChild(link);
        fragment.appendChild(listItem);
      } else {
        link.className = "rt-brand-submenu__link";
        fragment.appendChild(link);
      }
    });
    return fragment;
  }

  function ensureDesktopMenu() {
    var navigation = document.querySelector(".t4s-nav__ul");
    if (!navigation) {
      return;
    }

    navigation.querySelectorAll(":scope > li").forEach(function (item) {
      var topLink = item.querySelector(":scope > a");
      if (!topLink) {
        return;
      }
      var brand = brandForText(topLink.textContent);
      if (!brand) {
        return;
      }

      var existingMenu = item.querySelector(
        ".t4s-sub-menu:not(.rt-brand-submenu)",
      );
      if (existingMenu && existingMenu.children.length > 0) {
        return;
      }

      var fallback = item.querySelector(
        ":scope > .rt-brand-submenu",
      );
      if (!fallback) {
        fallback = document.createElement("div");
        fallback.className = "t4s-sub-menu rt-brand-submenu";
        fallback.setAttribute("data-rt-fallback", brand.key);
        item.appendChild(fallback);
      }
      if (!fallback.dataset.rtReady) {
        fallback.appendChild(buildLinks(brand, false));
        fallback.dataset.rtReady = "1";
      }
      item.classList.add("rt-has-fallback");
    });
  }

  function ensureMobileMenu(root) {
    var scope = root || document;
    scope
      .querySelectorAll("#menu-mb__ul a, #menu-mb__cat a")
      .forEach(function (topLink) {
        if (topLink.closest(".rt-mobile-brand-bar")) {
          return;
        }
        var brand = brandForText(topLink.textContent);
        var item = topLink.closest("li");
        if (!brand || !item) {
          return;
        }

        var existingMenu = item.querySelector(
          ":scope > .t4s-sub-menu:not(.rt-mobile-brand-submenu)",
        );
        if (existingMenu && existingMenu.querySelector("li")) {
          return;
        }

        var fallback = item.querySelector(
          ":scope > .rt-mobile-brand-submenu",
        );
        if (!fallback) {
          fallback = document.createElement("ul");
          fallback.className = "t4s-sub-menu rt-mobile-brand-submenu";
          fallback.setAttribute("data-rt-fallback", brand.key);
          fallback.appendChild(buildLinks(brand, true));
          item.appendChild(fallback);
        }
        item.classList.add(
          "t4s-menu-item-has-children",
          "rt-has-mobile-fallback",
        );
      });
  }

  function ensureMobileBrandBar() {
    var drawer = document.getElementById("t4s-menu-drawer");
    if (!drawer) {
      return;
    }
    var list = drawer.querySelector("#menu-mb__ul");
    if (!list || list.querySelector(".rt-mobile-brand-bar")) {
      return;
    }

    var item = document.createElement("li");
    item.className = "rt-mobile-brand-bar";

    var grid = document.createElement("div");
    grid.className = "rt-mobile-brand-bar__grid";

    brands.forEach(function (brand, index) {
      var target = brand.items[0];
      var link = document.createElement("a");
      link.href = target[1];
      link.className =
        "rt-mobile-brand-bar__item" +
        (index === 0 ? " rt-mobile-brand-bar__item--primary" : "");

      var role = document.createElement("small");
      role.textContent = brand.role;

      var label = document.createElement("span");
      label.textContent = brand.label;

      link.appendChild(role);
      link.appendChild(label);
      grid.appendChild(link);
    });

    item.appendChild(grid);
    list.insertBefore(item, list.firstChild);
  }

  function initialize() {
    ensureDesktopMenu();
    ensureMobileMenu(document);
    ensureMobileBrandBar();
    localizeFacets();

    document.addEventListener(
      "click",
      function (event) {
        var target = event.target;
        if (
          target &&
          target.closest &&
          target.closest(".t4s-btn-filter")
        ) {
          window.setTimeout(localizeFacets, 250);
        }
      },
      true,
    );

    if (!document.body || !window.MutationObserver) {
      return;
    }

    var queued = false;
    function refresh() {
      queued = false;
      ensureDesktopMenu();
      ensureMobileMenu(document);
      ensureMobileBrandBar();
      localizeFacets();
    }

    new MutationObserver(function (mutations) {
      if (queued) {
        return;
      }
      var relevant = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });
      if (!relevant) {
        return;
      }
      queued = true;
      window.setTimeout(refresh, 300);
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
